<template>
    <div>
        <div v-if="!noTranscript && !pendingTranscript">
            <span v-for="(segment, index) in transcript" :key="index" class="transcriptSegment"
                @click="segmentClicked(segment)">
                {{ segment.t }}
            </span>
        </div>
        <div v-if="pendingTranscript">
            <h6>Transcript processing. Please try again in a few minutes.</h6>
        </div>
        <div v-if="noTranscript">
            <h6>Transcript not available.</h6>
            <b-button variant="primary" @click="requestTranscript">Request Transcript</b-button>
        </div>
    </div>
</template>

<script lang="ts">
import { NotificationOptions } from "@/util/NotificationOptionsPresets";
import Axios from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    name: "TranscriptionViewer",
})
export default class TranscriptionViewer extends Vue {
    @Prop() private entityType!: number;
    @Prop() private entityId!: number | string;
    private transcript?: Array<any> = [];
    private pendingTranscript: boolean = false;
    private noTranscript: boolean = false;

    get normalizedEntityId(): number {
        return typeof this.entityId === 'string' ? parseInt(this.entityId, 10) : this.entityId;
    }

    mounted() {
        this.fetchTranscript();
    }

    fetchTranscript() {
        this.pendingTranscript = false;
        this.noTranscript = false;
        Axios.get(`Transcript/${this.entityType}/${this.normalizedEntityId}`).then((response) => {
            if (response.status == 204) {
                this.pendingTranscript = true;
            }
            this.transcript = response.data;
        }).catch((error) => {
            if (error.response.status == 404) {
                this.noTranscript = true;
                return;
            }
            this.$notification(NotificationOptions.error(error));
        });
    }

    segmentClicked(segment: any) {
        this.$emit("transcriptclick", this.normalizedEntityId, segment.s);
    }

    requestTranscript() {
        Axios.post(`Transcript/${this.entityType}/${this.normalizedEntityId}`)
            .then(() => {
                this.fetchTranscript();
            }).catch((error) => this.$notification(NotificationOptions.error(error)));
    }
}
</script>

<style scoped>
.transcriptSegment:hover {
    color: #0000FF;
    background-color: #CCCCCC;
    cursor: pointer;
}
</style>
